import {
  OfferCategory,
  OfferObjective,
  OfferPresentation,
} from '@bbkAdminUtils/api-client/rest-offers-api';

export const OFFER_OBJECTIVES_CATEGORY_MAPPING: {
  [objective in OfferObjective]: {
    categories: OfferCategory[];
    blockedPresentationsByCategory?: {
      [category in OfferCategory]?: OfferPresentation[];
    };
  };
} = {
  [OfferObjective.upsell]: {
    categories: [
      OfferCategory.plan_change,
      OfferCategory.support,
      OfferCategory.multi_cta,
      OfferCategory.multi_action,
    ],
  },
  [OfferObjective.retention]: {
    categories: [
      OfferCategory.discount,
      OfferCategory.pause,
      OfferCategory.plan_change,
      OfferCategory.extension,
      OfferCategory.support,
      OfferCategory.customer_feedback,
      OfferCategory.gifts_and_credits,
      OfferCategory.multi_cta,
      OfferCategory.multi_action,
      OfferCategory.other,
    ],
    blockedPresentationsByCategory: {
      [OfferCategory.other]: [OfferPresentation.modal],
    },
  },
  [OfferObjective.churn_deflection]: {
    categories: [
      OfferCategory.discount,
      OfferCategory.pause,
      OfferCategory.plan_change,
      OfferCategory.extension,
      OfferCategory.support,
      OfferCategory.customer_feedback,
      OfferCategory.gifts_and_credits,
      OfferCategory.multi_cta,
      OfferCategory.multi_action,
      OfferCategory.other,
    ],
  },
  [OfferObjective.churn_prevention]: {
    categories: [
      OfferCategory.discount,
      OfferCategory.pause,
      OfferCategory.plan_change,
      OfferCategory.extension,
      OfferCategory.support,
      OfferCategory.customer_feedback,
      OfferCategory.gifts_and_credits,
      OfferCategory.multi_cta,
      OfferCategory.multi_action,
    ],
  },
  [OfferObjective.acquisition]: {
    categories: [
      OfferCategory.trial_conversion,
      OfferCategory.extension,
      OfferCategory.multi_cta,
      OfferCategory.multi_action,
    ],
  },
};
